import template from './business-appointments.jade';
import { filterBusinessAppointmentsSelector } from '../../../../../../shared/selectors/business/filterBusinessAppointmentsSelector';
import { selectIsPublishedOffer } from '../../../../../../shared/selectors/offer';
import './business-appointments.css';

export default angular
  .module('cian.addForm.businessAppointments', [])
  .directive('cianAfAboutObjectBusinessAppointments', () => ({
    scope: {},
    bindToController: {
      form: '=',
      required: '=',
    },
    controller($rootScope, $scope, store, addFormService, deviceService) {
      'ngInject';

      let isBlured = false;

      const state = store.getState();
      $scope.ad = state.offer;
      $scope.isMobile = deviceService.isMobile;

      const isPublished = selectIsPublishedOffer(state);

      if (isPublished) {
        const matchedSpecialty = filterBusinessAppointmentsSelector(state);

        const payload = matchedSpecialty.length
          ? { specialties: matchedSpecialty, types: [matchedSpecialty[0].engName] }
          : undefined;

        addFormService.setValueByPath('specialty', payload);
      }

      $scope.isRequired = () => {
        const state = store.getState();
        const businessAppointments = filterBusinessAppointmentsSelector(state);

        return !businessAppointments.length;
      };

      $scope.isValid = () => !isBlured || !$scope.isRequired();

      $scope.onSelect = item => {
        addFormService.setValueByPath('specialty.specialties[0]', item);
        addFormService.setValueByPath('specialty.types', [item.engName]);

        $scope.$apply();
      };

      $scope.getErrorMessage = () => 'Выберите категорию бизнеса';

      $scope.onBlur = () => {
        isBlured = true;
      };

      $scope.$on('addform.submit', () => {
        isBlured = true;
      });
    },
    controllerAs: 'businessAppointments',
    template,
  })).name;
